








































































































































































import { TDictionary } from "@/assets";
import { Register, StackTransfer } from '@/constants';
import { SimulatorState } from "@/simulator";
import { default as explorer } from "./explorer.vue";
import { BModal } from "bootstrap-vue";
import Vue from 'vue';

type TTip = {
  name: string;
  tip: string;
  color: string;
}

export default Vue.extend({
  name: 'memory',
  components: {
    explorer
  },
  data() {
    return {
      tooltip: undefined as TTip | undefined,

      tips: {
        text: {
          name: "text",
          tip: "The text section contains the instructions defined in the .text section of the program.",
          color: "#0077aa"
        },
        data: {
          name: "data",
          tip: "The data section contains all the static data defined in the .data section of the program.",
          color: "#ff5555"
        },
        uninitialised: {
          name: "uninitialised memory",
          tip: "This section contains uninitialised memory waiting to be used by your program.",
          color: "#dcdcdc"
        },
        stack: {
          name: "stack",
          tip: "The stack contains data temporarily saved from CPU registers to prevent overwriting.",
          color: "#5d9455"
        },
        stackPointer: {
          name: "stack pointer",
          tip: "The stack pointer is a reference to the memory location which represents the current top of the stack.",
          color: "white"
        } 
      } as TDictionary<TTip>
    }
  },
  computed: {
    memory: SimulatorState.memory,
    registers: SimulatorState.registers,

    textWidth: function (): number {
      return this.memory.textHeight / this.memory.size * 100;
    },

    dataWidth: function (): number {
      return this.memory.dataHeight / this.memory.size * 100;
    },

    heapWidth: function (): number {
      return this.memory.heapHeight / this.memory.size * 100;
    },

    uninitWidth: function (): number {
      return Math.max(100 - this.textWidth - this.dataWidth - this.heapWidth - this.stackWidth, 0);
    },

    stackWidth: function (): number {
      return this.memory.stackHeight / this.memory.size * 100;
    },

    hoveredSection: function (): string | undefined {
      return this.tooltip?.name;
    },

    stackPointer: function (): number {
      const reversePtr = this.memory.size - this.registers[Register.SP];
      return (reversePtr / this.memory.size) * 100;
    },

    used: function (): number {
      return this.memory.textHeight + this.memory.dataHeight + this.memory.heapHeight + this.memory.stackHeight;
    }
  },
  methods: {
    tip: function (section: string) : void {
      this.tooltip = this.tips[section];
    },

    untip: function () : void {
      this.tooltip = undefined;
    },

    explore: function (section: string) {
      (this.$refs.explorer as any).show(section);
    }
  }
})
